import {
  Header as HeaderComponent,
  Variant,
} from 'app/components/Common/Header'
import { Props as MenuItemProps } from 'app/components/Common/Header/MenuItem'
import { Props as StickerProps } from 'app/components/Sticker'
import { graphql, StaticQuery } from 'gatsby'
import React, { memo } from 'react'
import { createContext } from 'react'

import { getHeaderProps } from './getHeaderProps'

export interface Props {
  bottomMenuItems: { [key: string]: MenuItemProps[] }[]
  email?: string
  IBEURL?: string
  languageCode?: string
  languagePrefix?: string | null
  logo?: string
  logoNegative?: string
  menuItems: { [key: string]: MenuItemProps[] }[]
  pageID?: string
  phone?: string
  quotationPageURL?: string
  siteName?: string
  stickerProps?: StickerProps
  whatsappNumber?: string
  whatsappURL?: string
  variant?: Variant
}

export const HeaderContext = createContext({})

export const Header = memo(function Header({
  bottomMenuItems,
  email,
  IBEURL,
  languageCode,
  languagePrefix,
  logo,
  logoNegative,
  menuItems,
  pageID,
  phone,
  quotationPageURL,
  siteName,
  stickerProps,
  whatsappNumber,
  whatsappURL,
  variant = 'default',
}: Props) {
  return (
    <StaticQuery
      query={graphql`
        query HeaderData {
          allSitePage {
            nodes {
              pageContext
              path
            }
          }
        }
      `}
      render={(data) => {
        const props = getHeaderProps(
          bottomMenuItems,
          data,
          languageCode || 'it-IT',
          menuItems,
          pageID,
        )

        return props ? (
          <HeaderContext.Provider
            value={{
              email,
              IBEURL,
              languageCode,
              languagePrefix,
              logo,
              logoNegative,
              phone,
              quotationPageURL,
              siteName,
              whatsappNumber,
              whatsappURL,
              variant,
            }}
          >
            <HeaderComponent {...props} stickerProps={stickerProps} />
          </HeaderContext.Provider>
        ) : null
      }}
    />
  )
})
